export default "/staticreactui/static/media/static/media/customer7.2c8a8702.webp";